// Mirror of the backend package catalog (crates/humanai-billing/src/catalog.rs).
// Ids MUST match the server; amounts/words are display-only (the server is the
// source of truth and re-validates on order creation). Names/blurbs are i18n
// keys — render through t().
import type { Lang } from "@/shared/i18n";

export type PackageId = "starter" | "standard" | "pro";

export interface PackageInfo {
  id: PackageId;
  name: string;
  /** USD price string (Stripe + stablecoin rails) — matches catalog.rs usd_cents. */
  usd: string;
  /** CNY price string (Alipay rail) — matches catalog.rs cny_cents. */
  cny: string;
  /** Words credited on payment — MUST match catalog.rs `tokens`. */
  words: number;
  blurb: string;
  highlight?: boolean;
}

export const CATALOG: PackageInfo[] = [
  {
    id: "starter",
    name: "Starter",
    usd: "6.90",
    cny: "49.00",
    words: 5_000,
    blurb: "For trying it out and small batches",
  },
  {
    id: "standard",
    name: "Standard",
    usd: "19.90",
    cny: "139.00",
    words: 20_000,
    blurb: "Steady daily use at a better rate",
    highlight: true,
  },
  {
    id: "pro",
    name: "Pro",
    usd: "49.90",
    cny: "349.00",
    words: 60_000,
    blurb: "High volume / teams, lowest rate",
  },
];

export const yuanFromCents = (cents: number): string =>
  (cents / 100).toFixed(2);

/** Compact word-credit display: en 20000 → "20,000 words", zh → "20,000 词". */
export function wordsLabel(n: number, lang: Lang = "en"): string {
  const num = n.toLocaleString("en-US");
  return lang === "zh" ? `${num} 词` : `${num} words`;
}
